// extracted by mini-css-extract-plugin
export var sticky = "NavSteps-module--sticky--2aZ4s";
export var outerNavContainer = "NavSteps-module--outer-nav-container--1c3uV";
export var innerNavContainer = "NavSteps-module--inner-nav-container--DmfM8";
export var nav = "NavSteps-module--nav--3mtP0";
export var sideNavLinks = "NavSteps-module--side-nav-links--1p4ny";
export var active = "NavSteps-module--active--CmXvG";